import "../../new.scss";
import { useState, useEffect, useContext } from "react";
import { EmpleadosFormContext } from '../../../context/empleados/EmpleadosContext';
import { useParams, useNavigate } from 'react-router-dom';
import { Tabs, Tab, Box } from '@mui/material';
import RolesModal from '../../roles/rolesModal/rolesModal';
import { AccionesEmpleadosState } from '../../../context/accionesempleados/AccionesEmpleadosState';
import AccionesEmpleadosGrid from './accionesEmpleados/accionesEmpleadosGrid';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";
import SucursalesModal from '../../sucursales/sucursalesModal/sucursalesModal';
import DepositosModal from '../../depositos/depositosModal/depositosModal';

export const Form = ({ title }) => {
  const [form, setForm] = useState({});
  const { postEmpleadoData, report, patchEmpleadoData } = useContext(EmpleadosFormContext);
  // Estado para controlar las pestañas
  const [tabIndex, setTabIndex] = useState(0);
  // id para edicion
  const { id } = useParams();
  const navigate = useNavigate();
  // Manejos de errores
  const [errors, setErrors] = useState({});
  //Estado de carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  //Dialogs de confirmacion y error
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  //Estado para filtros 
  const [searchFilter, setSearchFilter] = useState();
  const [searchDescFilter, setSearchDescFilter] = useState('');
  const [searchIdSucursal, setSearchIdSucursal] = useState();
  const [searchDescSucursal, setSearchDescSucursal] = useState('');
  const [searchIdDeposito, setSearchIdDeposito] = useState();
  const [searchDescDeposito, setSearchDescDeposito] = useState('');
  const nameData = "empleados";
  const saveData = postEmpleadoData;
  const updateData = patchEmpleadoData;

  useEffect(() => {
    setIsSubmitting(false)
   
    
    if (report && Object.keys(report).length > 0) {
      setForm(report);
      setSearchIdSucursal(report?.suc_id || ""); // Si no existe, asigna una cadena vacía
      setSearchDescSucursal(report["empl_suc"]?.["nombre"] || "No se encuentra la sucursal");

      setSearchIdDeposito(report?.depo_id || ""); // Si no existe, asigna una cadena vacía
      setSearchDescDeposito(report["empl_depo"]?.["depo_descripcion"] || "No se encuentra el deposito");

      setSearchDescFilter(report['empl-rol'].nombre || ""); // Inicialización segura
    }

  }, [report]);

  useEffect(() => {
    setIsSubmitting(false);
    if (searchFilter) {
      setForm((prevForm) => ({
        ...prevForm,
        rol_id: searchFilter, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchDescFilter) {
      setSearchFilter();
      setForm((prevForm) => ({
        ...prevForm,
        rol_id: null, // Establece la clave con un valor vacío en lugar de eliminarla
      }));
    }
  }, [searchDescFilter, searchFilter]);
  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdSucursal) {
      setForm((prevForm) => ({
        ...prevForm,
        suc_id: searchIdSucursal, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchDescSucursal) {
      setSearchIdSucursal(null);
      setSearchDescSucursal("");
      setSearchIdDeposito(null);
      setSearchDescDeposito("");
      setForm((prevForm) => ({
        ...prevForm,
        suc_id: null, // Establece la clave con un valor vacío en lugar de eliminarla
      }));
    }
  }, [searchDescSucursal, searchIdSucursal]);
  useEffect(() => {
    setIsSubmitting(false);
    if (searchIdDeposito) {
      setForm((prevForm) => ({
        ...prevForm,
        depo_id: searchIdDeposito, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchDescDeposito) {
      setSearchIdDeposito(null);
      setSearchDescDeposito("");
      setForm((prevForm) => ({
        ...prevForm,
        depo_id: null, // Establece la clave con un valor vacío en lugar de eliminarla

      }));
    }
  }, [searchDescDeposito, searchIdDeposito]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs, setErrors, form);
  };

  const validateForm = () => {
    let formErrors = {};
    Inputs.forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  const closeErrorDialog = () => setIsErrorDialogOpen(false);


  // Enviar datos
  const handleSendData = () => {
    if (!validateForm()) {
      // Usamos un callback para asegurarnos de que `errors` esté actualizado
      setErrors((prevErrors) => {
        const errorMessagesArray = Inputs.reduce((acc, { name, label }) => {
          if (prevErrors[name]) {
            const fieldLabel = label || name; // Usar el label si existe, si no, usar el nombre del campo
            acc.push(`${fieldLabel}: ${prevErrors[name]}`);
          }
          return acc;
        }, []);

        // Solo abrimos el diálogo de error cuando se hayan generado los mensajes
        if (errorMessagesArray.length > 0) {
          openErrorDialog(errorMessagesArray);
        }

        return prevErrors; // No modificamos el estado aquí
      });

      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();

    try {
      if (id) {
        await updateData(id, form);
      } else {
        await saveData(form);
      }
      navigate(`/${nameData}`);
    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/${nameData}`);
  };

  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <Tabs value={tabIndex} onChange={handleTabChange}>
              <Tab label="Datos Personales" />
              <Tab label="Acceso" />
              <Tab label="Permisos Preventistas" />
              <Tab label="Permisos Especiales" />

            </Tabs>
            {/* TAB GENERAL*/}
            <Box sx={{ padding: 2 }}>
              {tabIndex === 0 && (
                <>
                  <form>
                    {Inputs.slice(0, 4).map((input) => {
                      if (input.name === "rol_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <RolesModal
                              handleChange={setSearchFilter}
                              handleDescChange={setSearchDescFilter}
                              descSelected={searchDescFilter}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else {
                        return (
                          <FormField
                            key={input.id}
                            input={input}
                            value={form[input.name] || ""}
                            handleInputChange={(e) =>
                              handleInputChange(e, setForm, Inputs, setErrors, form)
                            }
                            error={errors[input.name]}
                          />
                        );
                      }
                    })}
                  </form>
                </>
              )}


              {/* TAB ACCESO*/}
              {tabIndex === 1 && (
                <>
                  <form>
                    {Inputs.slice(4, 8).map((input) => (
                      <FormField
                        key={input.id}
                        input={input}
                        value={form[input.name] || ""}
                        handleInputChange={(e) => handleInputChange(e, setForm, Inputs, setErrors, form)}
                        error={errors[input.name]}
                      />
                    ))}
                  </form>

                </>
              )}

              {/* TAB ACCESO*/}
              {tabIndex === 2 && (
                <>
                  <form>
                    {Inputs.slice(8, 12).map((input) => {
                      if (input.name === "suc_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <SucursalesModal
                              handleChange={setSearchIdSucursal}
                              handleDescChange={setSearchDescSucursal}
                              descSelected={searchDescSucursal}
                              handleDepoChange={setSearchIdDeposito}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else if (input.name === "depo_id") {
                        return (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <DepositosModal
                              handleChange={setSearchIdDeposito}
                              handleDescChange={setSearchDescDeposito}
                              idSelectorSuc={searchIdSucursal}
                              descSelected={searchDescDeposito}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      } else {
                        return (
                          <FormField
                            key={input.id}
                            input={input}
                            value={form[input.name] || ""}
                            handleInputChange={(e) =>
                              handleInputChange(e, setForm, Inputs, setErrors, form)
                            }
                            error={errors[input.name]}
                          />
                        );
                      }
                    })}
                  </form>

                </>
              )}

              {/* TAB MULTIMEDIA*/}
              {tabIndex === 3 && (
                <>
                  {id ? (
                    <>
                      <AccionesEmpleadosState>
                        <AccionesEmpleadosGrid
                          idEmpleado={form.id}
                          nombreEmpleado={form.sel_firstname}
                          apellidoEmpleado={form.sel_lastname}
                        />
                      </AccionesEmpleadosState>
                    </>
                  ) : (
                    <Box sx={{ padding: 2 }}>
                      <p>Debe guardar el registro antes de acceder a esta pestaña.</p>
                    </Box>
                  )}
                </>
              )}

            </Box>
            <form> </form>
              <FormButtons
                isSubmitting={isSubmitting}
                handleSave={handleSendData}
                handleCancel={handleCancel}
                saveText="Guardar"
                cancelText="Cancelar"
              />
            

            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>
      </div>
    </div >
  );
};

export default Form;
